if (!customElements.get('tabbed-content')) {
  class TabbedContent extends HTMLElement {
    connectedCallback() {
      const tabs = Array.from(this.querySelectorAll('[data-tabbed-content-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-tabbed-content-panel]'));

      if (!tabs.length || !panels.length) return;

      /*
       * Physically group tabs and panels into two separate
       * containers, rather than relying on CSS `order` +
       * display:contents (inconsistently honored across browsers).
       */
      const tablist = document.createElement('div');
      tablist.className = 'tabbed-content__tablist';
      tablist.setAttribute('role', 'tablist');

      const panelsWrap = document.createElement('div');
      panelsWrap.className = 'tabbed-content__panels';

      tabs.forEach((tab) => tablist.appendChild(tab));
      panels.forEach((panel) => panelsWrap.appendChild(panel));

      // Remove the now-empty leftover wrapper markup, then mount the rebuilt structure
      Array.from(this.children).forEach((child) => child.remove());
      this.appendChild(tablist);
      this.appendChild(panelsWrap);

      this.tabs = tabs;
      this.panels = panels;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.setActive(index));
      });

      this.setActive(0);
    }

    setActive(activeIndex) {
      this.tabs.forEach((tab, index) => {
        const isActive = index === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel, index) => {
        const isActive = index === activeIndex;
        panel.toggleAttribute('hidden', !isActive);
        panel.classList.toggle('is-active', isActive);
      });
    }
  }

  customElements.define('tabbed-content', TabbedContent);
}